$(function () {
    // On initialise les calendriers
    $('.portail-datetime').datetimepicker({});

    // Initialiser Select2 sur le sélecteur d'organisations
    $('#organisationSelector').select2({
        theme: 'bootstrap-5',
        placeholder: 'Rechercher une organisation...',
        allowClear: false,
        width: $( this ).data( 'width' ) ? $( this ).data( 'width' ) : $( this ).hasClass( 'w-100' ) ? '100%' : 'style',
        minimumInputLength: 0,
        templateResult: function(data) {
            if (!data.id) return data.text;
            
            // Extraire l'acronyme et le nom complet
            var parts = data.text.split(' - ');
            if (parts.length === 2) {
                return $('<span><strong>' + parts[0] + '</strong> - ' + parts[1] + '</span>');
            }
            return data.text;
        }
    });

    // Gérer le changement d'organisation
    $('#organisationSelector').on('change', function() {
        var organisationId = $(this).val();
            
        if (organisationId) {
            // Afficher un indicateur de chargement
            $(this).prop('disabled', true);
            $.ajax({

                url: $(this).data("url-change"),
                method: 'POST',
                data: {
                    organisation_id: organisationId
                },
                success: function(response) {
                    if (response.success) {
                        // Recharger la page pour appliquer le changement
                        window.location.reload();
                    } else {
                        alert('Erreur: ' + (response.message || 'Impossible de changer d\'organisation'));
                        $('#organisationSelector').prop('disabled', false);
                    }
                },
                error: function() {
                    alert('Erreur de connexion. Veuillez réessayer.');
                    $('#organisationSelector').prop('disabled', false);
                }
            });
        }
    });
    
    // Close any open menu accordions when window is resized below 768px
    $(window).resize(function () {
        if ($(window).width() < 768) {
            $('.sidebar .collapse').collapse('hide');
        };

        // Toggle the side navigation when window is resized below 480px
        if ($(window).width() < 480 && !$(".sidebar").hasClass("toggled")) {
            $("body").addClass("sidebar-toggled");
            $(".sidebar").addClass("toggled");
            $('.sidebar .collapse').collapse('hide');
        };
    });
});